import { useMemo } from 'react';
import { accountTransactionSimulationRequestSchema } from '@mls-wallet/shared-types';
import { useTransactionBuilderStore } from './useTransactionBuilderStore';
import { buildBatchAccountTransactionDraft } from './batch-transaction-draft';

/** Simulate the complete ordered cart under the shared account and network. */
export function useBatchSimulation() {
  const children = useTransactionBuilderStore(
    (state) => state.batchTransactions
  );
  const account = useTransactionBuilderStore((state) => state.account);
  const network = useTransactionBuilderStore((state) => state.network);
  const description =
    useTransactionBuilderStore((state) => state.description) ?? '';
  const revision = useTransactionBuilderStore((state) => state.draftRevision);
  const request = useMemo(() => {
    if (!account || network === undefined || children.length === 0) return null;
    try {
      const draft = buildBatchAccountTransactionDraft({
        multichainAccountId: account.id,
        networkId: network,
        // Descriptions are off-chain metadata and cannot change simulation.
        description,
        children,
      });
      accountTransactionSimulationRequestSchema.parse(draft);
      return draft;
    } catch {
      return null;
    }
  }, [account, network, children, description]);
  return { request, revision };
}
